import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _wrapNativeSuper from "@babel/runtime-corejs2/helpers/esm/wrapNativeSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";

/* tslint:disable:no-any */
export var SessionFoundError = /*#__PURE__*/function (_Error) {
  _inherits(SessionFoundError, _Error);

  var _super = _createSuper(SessionFoundError);

  function SessionFoundError(state) {
    var _this;

    _classCallCheck(this, SessionFoundError);

    _this = _super.call(this, 'SessionFoundError');

    _defineProperty(_assertThisInitialized(_this), "state", void 0);

    _this.state = state;
    return _this;
  }

  return SessionFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWJzL3Nlc3Npb24tZm91bmQtZXJyb3IudHMiXSwibmFtZXMiOlsiU2Vzc2lvbkZvdW5kRXJyb3IiLCJzdGF0ZSIsIkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7QUFDQSxXQUFhQSxpQkFBYjtBQUFBOztBQUFBOztBQUdFLDZCQUFZQyxLQUFaLEVBQXdCO0FBQUE7O0FBQUE7O0FBQ3RCLDhCQUFNLG1CQUFOOztBQURzQjs7QUFHdEIsVUFBS0EsS0FBTCxHQUFhQSxLQUFiO0FBSHNCO0FBSXZCOztBQVBIO0FBQUEsaUNBQXVDQyxLQUF2QyIsInNvdXJjZXNDb250ZW50IjpbIi8qIHRzbGludDpkaXNhYmxlOm5vLWFueSAqL1xuZXhwb3J0IGNsYXNzIFNlc3Npb25Gb3VuZEVycm9yIGV4dGVuZHMgRXJyb3Ige1xuICBwdWJsaWMgcmVhZG9ubHkgc3RhdGU6IGFueTtcblxuICBjb25zdHJ1Y3RvcihzdGF0ZTogYW55KSB7XG4gICAgc3VwZXIoJ1Nlc3Npb25Gb3VuZEVycm9yJyk7XG5cbiAgICB0aGlzLnN0YXRlID0gc3RhdGU7XG4gIH1cbn1cbiJdfQ==